<template>
  <b-card title="Apri nuova richiesta" class="mt-5">
    <b-row>
      <b-col>
        <b-form v-on:submit.prevent="createTicket">
          <h5 v-if="ticket.num">Richiesta #{{ ticket.num }}</h5>

          <b-form-group label="Seleziona Calendario" v-if="ticketTypes.length > 1">
            <b-form-select
              v-model="ticket.type"
              :options="ticketTypes"
              value-field="id"
              text-field="code"
              @change="updateAgenda"
            >
              <template slot="first">
                <option :value="null" disabled>-- Seleziona agenda --</option>
              </template>
            </b-form-select>
          </b-form-group>

          <b-form-group
            label="Seleziona giorno"
            :class="{ 'has-danger': errors.has('day') }"
          >
            <b-select
              v-validate
              data-vv-rules="required"
              data-vv-as="Data Intervento"
              name="slot"
              type="text"
              v-model="selected.day"
              :options="slots"
              value-field="day"
              text-field="day"
              required
              placeholder="Seleziona giorno"
              @change="onDaySelected"
            >
              <template slot="first">
                <option :value="null" disabled>-- Seleziona giorno --</option>
              </template>
            </b-select>
          </b-form-group>

          <b-form-group
            label="Seleziona fascia oraria"
            :class="{ 'has-danger': errors.has('slot') }"
          >
            <b-select
              v-validate
              data-vv-rules="required"
              data-vv-as="Data Intervento"
              v-model="ticket.slot_id"
              :options="selected.slots"

              value-field="id"
              text-field="start"
              placeholder="Seleziona fascia oraria">
              <template slot="first">
                <option :value="null" disabled>-- Seleziona fascia oraria --</option>
              </template>
            </b-select>
          </b-form-group>

          <b-form-group label="Note">
            <b-form-textarea
              v-model="ticket.customer_notes"
              placeholder="Inserisci note"
              :rows="4"
            ></b-form-textarea>
          </b-form-group>

          <b-form-group
            v-if="ticket.type === 'Onsite'"
            label="Indirizzo"
            :class="{ 'has-danger': errors.has('site_address') }"
          >
            <gmap-autocomplete
              class="input form-control"
              autocomplete="off"
              @place_changed="getAddressData"
            >
            </gmap-autocomplete>
          </b-form-group>

          <b-btn type="submit" :disabled="errors.any()">
            Invia Richiesta
          </b-btn>
          <b-btn variant="outline" @click="undoCreation">
            Annulla
          </b-btn>

          <!-- validator -->

          <b-alert v-if="errors.any()" show variant="danger" class="mt-3">
            Attenzione, assicurati di aver inserito tutti i dati richiesti!
          </b-alert>

          <!-- /validator -->
        </b-form>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "CreateTicket",
  props: {
    edit: {
      type: Object,
      default: null,
      required: false
    }
  },
  data: () => ({
    calendarConfig: {
      timezone: "Europe/Rome",
      selectable: false,
      editable: false,
      defaultView: "agendaWeek",
      nowIndicator: true,
      header: {
        left: "prev,next today",
        center: "",
        right: "title"
      },
      themeSystem: "bootstrap4",
      locale: "it",
      allDaySlot: false,
      scrollTime: "09:00",
      minTime: "09:00",
      maxTime: "19:00"
    },
    devices: [],
    ticket: {
      type: null,
      customer_id: null,
      user_id: null,
      slot_id: null,
      device_id: null,
      device_serial: null,
      status: "Nuovo",
      customer_notes: "",
      activity: "Sostituzione Smartphone Aziendale",
      category: "Assistenza",
      subcategory: "Sostituzione Smartphone Aziendale",
      onsite_info: null
    },
    agendas: [],
    activities: [],
    slots: [],
    ticketTypes: [],
    ticketAcitivities: [
      {
        name: "Malfunzionamento: Hardware",
        category: "Malfunzionamento",
        subcategory: "Hardware"
      },
      {
        name: "Malfunzionamento: Software",
        category: "Malfunzionamento",
        subcategory: "Software"
      },
      {
        name: "Assistenza: Configurazioni generali",
        category: "Assistenza",
        subcategory: "Configurazioni generali"
      },
      {
        name: "Assistenza: Ritiro Dispositivi",
        category: "Assistenza",
        subcategory: "Ritiro Dispositivi"
      }
    ],
    selected: {
      day: null,
      slots: [],
      assistance: null,
      customer: null,
      user: null,
      device: null,
      slot: null
    }
  }),

  computed: {
    ...mapState({
      user: state => state.user,
      devices: state => state.devices
    }),
    eventSources() {
      return [
        {
          events: this.getCalendareEvents
        }
      ];
    }
  },

  async mounted() {
    this.restoreData();
    await this.getData();
  },

  methods: {
    async getData() {
      this.ticketTypes = await this.$apiclient.getAgendas();

      if (this.ticketTypes.length > 0) {
        this.onCalendarSelected(0);
      }
    },

    async onCalendarSelected(id) {
      console.info('Selezionata agenda: ' + this.ticketTypes[id].code);

      this.ticket.type = this.ticketTypes[id].id;
      this.selected.slot = null;

      this.ticket.slot_id = null;

      this.slots  = await this.$apiclient.getSlots(
        this.ticketTypes[id].id,
        moment().format("YYYY-MM-DD"),
        moment().add(30,'days').endOf('week').format("YYYY-MM-DD"),
        "list"
      );
    },

    onDaySelected(day) {
      this.ticket.slot_id = null;
      this.selected.slots = this.slots.find(d => (d.day === day)).slots;
    },

    async createTicket() {
      await this.$validator.validateAll();

      if (this.errors.any()) {
        return;
      }

      const confirm = await this.$swal({
        icon: "info",
        title: "Apertura Richiesta",
        text: "Procedere con l'apertura della richiesta?",
        buttons: ["Annulla", "Procedi"]
      });

      if (!confirm) {
        return;
      }

      try {
        const ticket = await this.$apiclient.createTicket({
          ticket: this.ticket
        });

        this.$swal({
          icon: "success",
          title: "Apertura Richiesta",
          text:
            "Richiesta aperta correttamente. Verrai ricontattato da uno dei nostri tecnici nello slot concordata."
        });

        this.$emit("ticket-created");
      } catch (err) {
        console.log("Creazione ticket", err);
        this.$swal(
          "Oops",
          "Non è stato possibile inviare la richiesta: " + err.message,
          "error"
        );
      }
    },

    undoCreation() {
      this.$emit("ticket-created");
    },

    restoreData() {
      if (!this.edit) return;

      this.ticket.id = this.edit.id;
      this.ticket.type = this.edit.type;
      this.ticket.num = this.edit.num;
      this.ticket.activity = this.edit.activity;
      this.ticket.category = this.edit.category;
      this.ticket.subcategory = this.edit.subcategory;
      this.ticket.onsite_info = this.edit.onsite_info;
      this.ticket.customer_notes = this.edit.customer_notes;
      this.selected.slot = this.$moment(this.edit.slot.start).format(
        "DD/MM/YYYY HH:mm"
      );
      this.ticket.slot_id = this.edit.slot_id;
    },

    updateAgenda(agenda) {
      console.log("updateAgenda", agenda);

      // TODO: make it dynamic
      this.selected.assistance = agenda;
      this.selected.slot = null;
      this.ticket.slot_id = null;
      this.$nextTick(() => this.reloadEvents());
    },

    async getCalendareEvents(start, end, timezone, callback) {
      if (!this.selected.assistance) {
        this.$toastr.warning("Selezionare una tipologia di slot");
        return callback([]);
      }
      const data = await this.$apiclient.getSlots(
        this.selected.assistance,
        start.format("YYYY-MM-DD"),
        end.format("YYYY-MM-DD"),
        "list"
      );

      const slots = data.map(s => ({
        id: s.id,
        start: s.start,
        end: moment(s.start).add(s.duration, "minutes")
      }));

      console.log("slots", slots);

      return callback(data);
    },

    selectedActivity(selected) {
      const activity = _.find(this.ticketAcitivities, a => a.name === selected);
      this.ticket.activity = selected;
      this.ticket.category = activity.category;
      this.ticket.subcategory = activity.subcategory;
    },

    reloadEvents() {
      this.$refs.calendar.$emit("refetch-events");
    },

    slotSelected(slot) {
      this.ticket.slot_id = slot.id;
      this.selected.slot = this.$moment(slot.start).format("DD/MM/YYYY HH:mm");
    },

    getAddressData(addressData) {
      console.log(addressData);
      this.ticket.onsite_info = this.parseAddressData(addressData);
    },

    parseAddressData(place) {
      if (!place.geometry) {
        return null;
      }

      const addressComponents = {
        formatted_address: "formatted_address",
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_1: "short_name",
        administrative_area_level_2: "short_name",
        country: "long_name",
        postal_code: "short_name"
      };

      const returnData = {};
      returnData.formatted_address = place.formatted_address;

      if (place.address_components !== undefined) {
        // Get each component of the address from the place details
        for (let i = 0; i < place.address_components.length; i++) {
          const addressType = place.address_components[i].types[0];

          if (addressComponents[addressType]) {
            const val =
              place.address_components[i][addressComponents[addressType]];
            returnData[addressType] = val;
          }
        }

        returnData.latitude = place.geometry.location.lat();
        returnData.longitude = place.geometry.location.lng();

        return returnData;
      }
      return null;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/AreaRiservata/CreateTicket.vue